module.exports = __webpack_public_path__ + "img/icon_contact_logo_ins.b349c5b1.png";